function getFeaturesState(state) {
  return {
    unitMeasurement: state.features.unitMeasurement,
    formValues: state.features.formValues,
    antiquityType: state.features.antiquityType,
    loading: state.features.loading,
    fetchError: state.features.fetchError,
    fetchCompleted: state.features.fetchCompleted,
    hasSavedData: state.features.hasSavedData
  };
}

export { getFeaturesState };
